/*---------------------------------------------------------*\
 * HeaderSecondaryController
\*---------------------------------------------------------*/
class HeaderSecondaryController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor() {
    this.name = 'headerSecondary';
  }
}

export default HeaderSecondaryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/headerSecondary/headerSecondary.controller.js
 **/